import ModalsLib from '../lib/modals';
import {getState, dispatch} from '../lib/store';
import types from '../reducers/user/types';
import API from '../lib/api';

import {toggleActionModal} from '../reducers/modals-action/actions';

export const openPendingActionModal = () => {
    if(window.pendingPromotionModal.length > 0) {
        console.log(window.pendingPromotionModal);

        dispatch(toggleActionModal(window.pendingPromotionModal[0]));
        window.pendingPromotionModal = window.pendingPromotionModal.filter(a => a !== window.pendingPromotionModal[0]);
    }
}

const timeout = ms => new Promise((resolve) => setTimeout(resolve, ms, true));

const initializeModals = async() => {
    await timeout(5e3);

    if(window.pendingPromotionModalInitialized)
        return;

    const {app, user} = getState();

    const response = await API.call({
        path: '/promotions/modals/initialize',
        body: {
            isMobile: app.isMobile,
            standalone: 'standalone' in window.navigator && window.navigator.standalone,
            notifications: 'Notification' in window,
            telegram: typeof window.Telegram.WebApp.initDataUnsafe.user !== "undefined"
        }
    });

    window.pendingPromotionModalInitialized = true;
    window.pendingPromotionModal = response.success ? response.modals : [];

    openPendingActionModal();

    // // const {user} = getState();

    // // if(user.modals_list && user.modals_list.length > 0) {
    // //     ModalsLib.open(user.modals_list[0]);
    // // } else {
    // //     setTimeout(() => {
    // //         searchActionModals();
    // //     }, 5e3);
    // // }

    // dispatch(toggleActionModal('notifications'));
    // dispatch(toggleActionModal('cashapp-available'));
}



const searchActionModals = async() => {
    const response = await API.call({
        path: '/promotions/getActionModals'
    });

    if(response.success && response.modal)
        ModalsLib.open(response.modal);

    window.action_modal_timeout = setTimeout(searchActionModals, (3 * 60 * 1e3));
}

export const closePromotionModal = async (key) => {
    await API.call({
        path: '/promotions/modals/trigger',
        body: {
            key,
            trigger: 'close'
        }
    });

    openPendingActionModal();

    // dispatch({
    //     type: types.promotions.modals.remove,
    //     payload: key
    // });

    // // Search next modal to show
    // // initializeModals();
    // const {user} = getState();

    // if(user.modals_list && user.modals_list.length > 0) {
    //     ModalsLib.open(user.modals_list[0]);   
    // } else {
    //     ModalsLib.close()

    //     setTimeout(() => {
    //         searchActionModals();
    //     }, 5e3);
    // }
}

export const clickPromotionModal = async (key, callback = false) => {
    await API.call({
        path: '/promotions/modals/trigger',
        body: {
            key,
            rest_modals: window.pendingPromotionModal,
            trigger: 'click'
        }
    });


    // openPendingActionModal();
    // dispatch({
    //     type: types.promotions.modals.clear
    // });

    if(callback)
        callback();
}

export default {
    initializeModals,
    closePromotionModal,
    clickPromotionModals: clickPromotionModal
}